import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IPaymentAgreement, IPaymentAgreementVerify } from 'modules/conciliation/payment-agreement/interfaces';

class PaymentAgreementService extends EntityApiService<IPaymentAgreement> {
  verify = (filters: any, search: any): Promise<IPaymentAgreementVerify> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/verify'), { filters, search }));
  };

  add = (paymentId: string, params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/add-suborders'), { ...params, paymentId }));
  };

  remove = (paymentAgreementId: string, filters: any) => {
    if (paymentAgreementId) {
      return this.handleResponse(
        ApiClientService.post(this.getPath('/remove-suborders'), {
          paymentId: paymentAgreementId,
          filters,
        }),
      );
    }
    throw new Error('required paymentAgreementId');
  };
}

export default new PaymentAgreementService('/ms-sales/api/payment-agreement');
